<template>
  <div >
    <div class="Htab" v-if="hdtab.length>0">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane :label="item.label" v-for="(item,index) in hdtab" :key="index" :name="item.label"
              :value="item.value"></el-tab-pane>
          </el-tabs>
    </div>
  </div>
</template>
<script>
  import GlobalUtil from '@/utils/globalUtil';
  export default {
    props: {
      viewList: {
        type: Array,
        default: function () {
          return []
        }
      },
      btnList: {
        type: Array,
        default: function () {
          return [{
            type: 'add',
            name: '新增'
          }, {
            type: 'reload',
            name: '刷新'
          }, {
            type: 'report',
            name: '导出'
          }]
        }
      },
      selectOptions: {
        type: Array,
        default: function () {
          return []
        }
      },
      // tab菜单切换
      hdtab: {
        type: Array,
        default: function () {
          return []
        }
      },
      // 文字宽度
      labelWidth: {
        type: String,
        default: '110px'
      },
      // 过滤字段
      searchFormData: {
        type: Array,
        default: function () {
          []
        }
      }
    },
    data() {
      return {
        flag: false,
        activeName: null,
        typeValue: '',
        searchValue: '',
        showForm: false,
        outData: {},
        viewValue: ''
      }
    },
    created() {
      if (this.hdtab.length) {
        this.activeName = this.hdtab[0].label
      }
      // console.log(this.hdtab)
      // this.formRule = GlobalUtil.deepCopy(this.reformRule)
      if (this.selectOptions && this.selectOptions.length > 0) {
        this.typeValue = this.selectOptions[0].value
      }
      if (this.viewList && this.viewList.length > 0) {
        this.viewValue = this.viewList[0].value
      }
    },
    mounted() {

    },
    methods: {
      returnObj() {
        if (this.selectOptions) {
          if (this.searchValue) {
            // 定义最大字节
            var maxtext = 20;
            var d = 0
            // 匹配汉字
            if (this.searchValue.match(/[\u4e00-\u9fa5]/g)) {
              d = this.searchValue.match(/[\u4e00-\u9fa5]/g).length
            }
            maxtext = maxtext - d
            // 匹配字母，数字，不为空和汉字
            var str = '/^[\u4e00-\u9fa5a-zA-Z0-9]{1,' + maxtext + '}$/'
            if (!(eval(str).test(this.searchValue))) {
              this.$message.error('请输入合法关键字符')
            } else {
              return {
                type: this.typeValue,
                value: this.searchValue
              }
            }
          } else {
            return {
              type: this.typeValue,
              value: this.searchValue
            }
          }
        } else {
          return this.searchValue
        }
      },
      viewValueChange(data) {
        this.$emit('viewValueChange', data)
      },
      handleClick(tab, event) {
        // console.log(tab.$attrs);
        this.$emit('htabAction', tab.$attrs.value)
      },
      advancedSearch() {
        this.flag = true;
      },
      close() {
        this.flag = false;
      },
      confirm() {
        let obj = this.$refs.myform.submitForm();
      },
      btnAction(str) {
        this.$emit('btnAction', str)
      },
      searchAction() {
        if (this.selectOptions) {
          if (this.searchValue) {
            // 定义最大字节
            var maxtext = 20;
            var d = 0
            // 匹配汉字
            if (this.searchValue.match(/[\u4e00-\u9fa5]/g)) {
              d = this.searchValue.match(/[\u4e00-\u9fa5]/g).length
            }
            maxtext = maxtext - d
            // 匹配字母，数字，不为空和汉字
            var str = '/^[\u4e00-\u9fa5a-zA-Z0-9]{1,' + maxtext + '}$/'
            if (!(eval(str).test(this.searchValue))) {
              this.$message.error('请输入合法关键字符')
            } else {
              this.$emit('searchAction', {
                type: this.typeValue,
                value: this.searchValue
              });
            }
          } else {
            this.$emit('searchAction', {
              type: this.typeValue,
              value: this.searchValue
            });
          }
        } else {
          this.$emit('searchAction', this.searchValue);
        }
      },
      submitForm() {
        let obj = this.outData;
        obj.acthd = this.acthd;
        this.$emit('filterRes', obj)
      },
      resetForm() {
        for (let item in this.outData) {
          this.outData[item] = ''
        }
      }
    }
  }

</script>
<style>
  .Htab .el-tabs__content {
    display: none;
  }
  .Htab .el-tabs--card>.el-tabs__header{
    /* border: none; */
  }
  .Htab .el-tabs__header{
    margin-bottom: 0px;
  }
  .Htab .el-tabs--card > .el-tabs__header .el-tabs__item{
    /* background: #ffffff; */
  }
  .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
    /* height: 40px; */
    background: #ffffff
  }
</style>
<style scoped>
.float_btn{
  float: left;
  margin-left: 8px;
}
.backFF{
  background: #ffffff;
  /* border:1px solid rgba(229,229,229,1); */
  /* border- */
}
  .bit_list_item {
    padding-right: 20px;
  }

  .view_box {
    float: left;
    line-height: 32px;
    margin-right: 20px;
  }

  .view_box .view_name {
    float: left;
    margin-right: 10px;
    font-size: 14px;
  }

  .view_select {
    float: left;
  }

  .my_el_form {
    display: flex;
    flex-wrap: wrap;
    padding-right: 25px;
  }

  .form_item {
    display: flex;
  }

  .all_hd {
    display: flex;
  }

  .folding {
    display: flex;
    /* margin-bottom: 20px; */
    padding-top: 18px;
  }

  .bit_list {
    display: flex;
  }

  .text_btn {
    color: #108EEA;
    cursor: pointer;
  }

  .search_btn {
    background: #108EEA;
    color: #ffffff;
    margin-left: 20px;
  }

  .reset_btn {
    border: 1px solid #e6e6ee;
    color: #888;
    margin-left: 20px;
  }

  .hd_item {
    border: 1px solid #e6e6ee;
    color: #888;
  }

  .act_item {
    color: #108EEA;
    border-color: #108EEA
  }

</style>

<style scoped lang="scss">
  .searchselect {
    width: 100%;
    min-width: 120px;
  }

  .search-header {
    overflow: hidden;
    background: #fff;
    padding-left: 20px;
    padding-right: 8px;

    .header-title {
      /* margin-right:20px; */
      font-size: 14px;
      line-height: 30px;
      float: left;
    }

    .header-left {
      float: left;
      margin-right: 15px;
      width: 100px;
      /* display: flex; */
    }

    .header-right {
      /* width: 500px; */
      /* display: flex; */
      margin-left: 20px;
      float: left;
    }

    .search-input {
      float: left;
      width: 380px;
    }

    .search-btn {
      margin: 0 15px;
      float: right;
      width: 120px;
      background: #6890FE;
    }
  }

</style>
